import { accentText } from './accent-text';
import { resolveRawThemeEffect } from './schemes';

export * from './schemes';
export * from './accent-text';

export const themeEffects = Object.freeze(
  [accentText].map((raw) => resolveRawThemeEffect(raw)),
);
